import React, {FC, useEffect, useState} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import SmartbetLobbyComponent from "../Components/SmartbetLobbyComponent";
import {Link} from "react-router-dom";
import {Alert} from "react-bootstrap";
interface STLProps {
    atagParams: string | null
    viewType?: string | null
    sourceParams: string | null,
    ticketOpenMode: string | null,

}
const SmartbetLobby: FC <STLProps> = ({atagParams, viewType, sourceParams, ticketOpenMode}) => {
    const {getSmartBetsData} = useAction();
    const {smartBetsData} = useTypedSelector((state) => state.smartBetsReducer);

    useEffect(()=>{
        getSmartBetsData();
    }, [])
    return(
        <>
            {smartBetsData.length > 0 ?
                <SmartbetLobbyComponent
                    viewType={viewType}
                    ticketOpenMode={ticketOpenMode}
                    data={smartBetsData}
                    sourceParams={sourceParams}
                    atagParams={atagParams}
                />
                : null
            }
        </>
    )

}

export default SmartbetLobby;
